"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopTeamAllOfToJSON = exports.TopTeamAllOfFromJSONTyped = exports.TopTeamAllOfFromJSON = void 0;
function TopTeamAllOfFromJSON(json) {
    return TopTeamAllOfFromJSONTyped(json, false);
}
exports.TopTeamAllOfFromJSON = TopTeamAllOfFromJSON;
function TopTeamAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isClosed': json['isClosed'],
        'isFinished': json['isFinished'],
    };
}
exports.TopTeamAllOfFromJSONTyped = TopTeamAllOfFromJSONTyped;
function TopTeamAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'isClosed': value.isClosed,
        'isFinished': value.isFinished,
    };
}
exports.TopTeamAllOfToJSON = TopTeamAllOfToJSON;
